export default __webpack_public_path__ + "static/media/erp.f8329f71.png";